import React, { Component } from 'react';
import { connect } from 'react-redux';
import { pending, rejected, done } from 'redux-saga-thunk';
import { withRouter } from 'react-router';
import { compose } from 'redux';
import get from 'lodash/get';
import moment from 'moment/moment';
import { reduxForm } from 'redux-form';
import { notification } from 'antd';
import { fromEntities, fromResource } from '../../store/selectors';
import AudienceForecastTab from '../../components/molecules/AudienceForecastTab/index';
import { createValidator, required } from '../../services/validation/index';
import {
  resourceCreateRequest,
  resourceDetailReadRequest,
  resourceListReadRequest,
  resourceUpdateRequest,
} from '../../store/resource/actions';
import { modalHide, modalShow } from '../../store/modal/actions';
import { isOpen } from '../../store/modal/selectors';
import {
  startPollingForQueryStatus,
  stopPollingForQueryStatus,
} from '../../store/audiences/actions';
import { setEditRecord, emptyEditRecord } from '../../store/updateCampaign/actions';

class AudienceForecastTabContainer extends Component {
  componentDidMount() {
    this.props.getAudienceList().catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not retrieve audience.',
        duration: 0,
      });
    });
  }

  componentDidUpdate(prevProps) {
    const thisId = get(this.props, 'selectedAudience.id');
    if (thisId && thisId !== get(prevProps, 'selectedAudience.id')) {
      this.props.getAudience(this.props.selectedAudience.id);
    }
  }

  render() {
    return <AudienceForecastTab {...this.props} />;
  }
}

const ranText =
  'Create a targeted revision to find device reach after there is a unique device count';
const notRanText = 'Total available devices based on locations';

const mapStateToProps = state => {
  const totalDevices = get(state, 'resource.forecastRevisionAudience.count', 0);
  const useStandardSql = !!fromEntities.getDetail(
    state,
    'forecastRevisionAudience',
    `${get(state, 'updateCampaign.id', {})}.use_standard_sql`
  );
  let audienceList = [
    { name: totalDevices ? notRanText : ranText, device_count: totalDevices, onClick: null },
  ];

  audienceList = audienceList.concat(
    fromEntities.getList(
      state,
      'forecastRevisionAudience',
      fromResource.getList(state, 'forecastRevisionAudience')
    )
  );

  return {
    selectedAudience: get(state, 'updateCampaign', {}),
    audienceList,
    visible: isOpen(state.modal, 'audience-query'),
    loadingAudienceQuery: pending(state, 'forecastRevisionAudienceCreate'),
    doneAudiencesQuery: done(state, 'forecastRevisionAudienceCreate'),
    doneDeleteAudiencesQuery: done(state, 'forecastRevisionAudienceDelete'),
    fetching: pending(state, 'forecastRevisionAudienceListRead'),
    fetchingAudience: pending(state, 'forecastRevisionAudienceDetailRead'),
    isPolling: get(state, 'audiences.pollingForQuery'),
    failed: rejected(state, 'forecastRevisionAudienceListRead'),
    errorMessage: fromResource.getError(state, 'forecastRevisionAudience'),
    initialValues: {
      query: `SELECT
 v.di_device_uuid as devices
FROM (
SELECT
di_create_dtime,
di_device_uuid
FROM
TABLE_DATE_RANGE(m2m_detections.device_ibeacon_, TIMESTAMP('${moment()
        .subtract(1, 'M')
        .format('YYYY-MM-DD')}'), TIMESTAMP('${moment().format('YYYY-MM-DD')}'))
WHERE
lg_chain_id in (235)) v
JOIN
  (select device_uuid from [Manisha.Parents_devices_new] ) p
ON
p.device_uuid=v.di_device_uuid
GROUP BY 1
ORDER BY 1 ASC;`,
      useStandardSql,
      ...fromEntities.getDetail(
        state,
        'forecastRevisionAudience',
        get(state, 'updateCampaign.id', {})
      ),
    },
  };
};

const mapDispatchToProps = (
  dispatch,
  {
    match: {
      params: { forecastId, revisionId },
    },
  }
) => ({
  setEditRecord: record => {
    dispatch(setEditRecord(record));
    return dispatch(modalShow('audience-query'));
  },
  pollForQueryStatusStart: uuid =>
    dispatch(
      startPollingForQueryStatus({
        params: { forecastId, revisionId },
        uuid,
        endpoint: `forecast/:forecastId/revision/:revisionId/audience`,
      })
    ),
  pollForQueryStatusStop: uuid => dispatch(stopPollingForQueryStatus(uuid)),
  hide: () => {
    // Timeout because hiding is a slow fade.
    // We don't want to flash the form resetting
    setTimeout(() => dispatch(emptyEditRecord()), 100);

    return dispatch(modalHide('audience-query'));
  },
  show: () => dispatch(modalShow('audience-query')),
  getAudienceList: () =>
    dispatch(
      resourceListReadRequest(
        'forecast/:forecastId/revision/:id/audience',
        {},
        {
          forecastId,
          id: revisionId,
        }
      )
    ),
  getAudience: id =>
    dispatch(
      resourceDetailReadRequest('forecast/:forecastId/revision/:revisionId/audience/:id', {
        forecastId,
        revisionId,
        id,
      })
    ),
  createAudience: data =>
    dispatch(
      resourceCreateRequest(
        'forecast/:forecastId/revision/:id/audience',
        { forecastId, id: revisionId },
        data
      )
    ),
  updateAudience: data =>
    dispatch(
      resourceUpdateRequest(
        'forecast/:forecastId/revision/:revisionId/audience/:id',
        { forecastId, id: data.id, revisionId },
        data
      )
    ),
});

const onSubmit = (values, dispatch, { selectedAudience, hide, createAudience, updateAudience }) => {
  if (selectedAudience.id) {
    return updateAudience(values)
      .then(r => {
        notification.success({ message: 'Success', description: 'Audience updated', duration: 4 });
        hide();
      })
      .catch(e => {
        notification.error({
          message: 'Error',
          description: typeof e === 'string' ? e : 'Could not update audience.',
          duration: 0,
        });
      });
  }
  return createAudience(values)
    .then(r => {
      notification.success({ message: 'Success', description: 'Audience created', duration: 4 });
      hide();
    })
    .catch(e => {
      notification.error({
        message: 'Error',
        description: typeof e === 'string' ? e : 'Could not create audience.',
        duration: 0,
      });
    });
};

const validate = createValidator({
  name: [required],
  query: [required],
});

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  reduxForm({
    enableReinitialize: true,
    form: 'AudienceForecastTab',
    onSubmit,
    validate,
  })
)(AudienceForecastTabContainer);
